module.exports = __webpack_public_path__ + "static/media/down-arrow.0230fe76.svg";